import {AppsyncService} from './AppsyncService'
import gql from "graphql-tag";
import {oktaAuth} from "../config/OktaConfig";
import { findShipmentsById } from '../../graphql/shipment/queries';

export class ShipmentService {

    appsyncService : AppsyncService;

    constructor() {
        this.appsyncService = new AppsyncService(process.env.REACT_APP_APPSYNC_SHIPMENT_ENDPOINT!, oktaAuth)
    }

    async getShipmentInfo(shipmentId: string): Promise<any> {
        return this.appsyncService.appSyncClient.query({
                query: gql(findShipmentsById), fetchPolicy: 'network-only', variables: {
                    shipmentIds: [ shipmentId ]
                }
            }
        );
    }

}